import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { fmt } from '@components/ProductOffers/modals/ShoppingCartDrawer/utils/pricingSummary.utils';
import { PricingRow } from '@components/ProductOffers/modals/ShoppingCartDrawer/ShoppingCartDrawer.styles';

import type { OrderTotalsProps } from './OrderTotals.types';

export const OrderTotals = ({ monthlyTotal, oneTimeTotal }: OrderTotalsProps) => (
  <Stack spacing={1} useFlexGap sx={{ padding: '20px 24px' }}>
    <Typography
      className="OrderSummaryTitle"
      sx={{
        fontFamily: 'Agrandir',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '100%',
      }}
    >
      Total
    </Typography>

    <PricingRow>
      <Typography className="OrderSummaryText" sx={{ fontFamily: 'Roboto', fontWeight: 700, fontSize: '14px' }}>
        Total Recurring Monthly Charges
      </Typography>
      <Typography className="OrderSummaryText" sx={{ fontFamily: 'Roboto', fontWeight: 700, fontSize: '14px' }}>
        {fmt(monthlyTotal)}
      </Typography>
    </PricingRow>

    <PricingRow>
      <Typography className="OrderSummaryText" sx={{ fontFamily: 'Roboto', fontWeight: 700, fontSize: '14px' }}>
        Total One Time Charges
      </Typography>
      <Typography className="OrderSummaryText" sx={{ fontFamily: 'Roboto', fontWeight: 700, fontSize: '14px' }}>
        {fmt(oneTimeTotal)}
      </Typography>
    </PricingRow>

    <Typography className="OrderSummaryText" sx={{ fontFamily: 'Roboto', fontWeight: 400, fontSize: '12px', mt: '4px' }}>
      All prices are in <strong>Canadian Dollars (CAD)</strong>
    </Typography>

    <Typography className="OrderSummaryText" sx={{ fontFamily: 'Roboto', fontWeight: 400, fontSize: '12px', mt: '4px' }}>
      **Your first bill may be slightly higher due to a small prorated charge before your first billing cycle begins.
    </Typography>
  </Stack>
);
